// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.receipt-container {
  width: 100%;
  max-width: 576px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  padding: 20px 16px;
  margin: 0 auto;
  min-height: calc(100vh - 80px);
}
/*# sourceMappingURL=ReceiptPage.css.map */`, "",{"version":3,"sources":["webpack://./ReceiptPage.less","webpack://./src/containers/ReceiptPage/ReceiptPage.less"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;ACCD;AACA,0CAA0C","sourcesContent":[".receipt-container {\n\twidth: 100%;\n\tmax-width: 576px;\n\tbackground-color: #ffffff;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 20px 16px;\n\tmargin: 0 auto;\n\tmin-height: calc(100vh - 80px);\n}\n",".receipt-container {\n  width: 100%;\n  max-width: 576px;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: column;\n  padding: 20px 16px;\n  margin: 0 auto;\n  min-height: calc(100vh - 80px);\n}\n/*# sourceMappingURL=ReceiptPage.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
